var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFound"},[_c('div',[_c('div',{staticClass:"title"},[_vm._v("NOT FOUND")]),_c('div',{staticClass:"subTitle"},[_vm._v(" The Page Was Not Found or "),_c('span',{staticClass:"word"},[_vm._v("Coming soon.")])])])])
}]

export { render, staticRenderFns }